import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const constantRouterMap = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/view/home')
  },
  {
    path: '/result',
    name: 'result',
    component: () => import('@/view/result')
  },
  {
    path: '/ccie',
    name: 'ccie',
    component: () => import('@/view/ccie')
  },
  {
    path: '/ccieDetail',
    name: 'ccieDetail',
    component: () => import('@/view/ccieDetail')
  },
  {
    path: '/webView',
    name: 'webView',
    component: () => import('@/view/webView')
  },
  {
    path: '*',
    redirect: { name: 'home' }
  }
]

const router = new Router({
  mode: 'history',
  // base: process.env.NODE_ENV,
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js